import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApprovalFlowDefinition } from '../approval/models/approval-flow-definition.model';
import { ApprovalService } from '../approval/services/approval.service';

@Component({
  selector: 'app-approval-flow-selector',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './approval-flow-selector.component.html',
  styleUrls: ['./approval-flow-selector.component.scss']
})
export class ApprovalFlowSelectorComponent implements OnInit {
  @Output() flowSelected = new EventEmitter<ApprovalFlowDefinition>();
  @Output() flowDeselected = new EventEmitter<void>();

  flowDefinitions: ApprovalFlowDefinition[] = [];
  selectedFlow: ApprovalFlowDefinition | null = null;
  loading = false;
  error: string | null = null;

  constructor(private approvalService: ApprovalService) {}

  ngOnInit(): void {
    this.loadFlowDefinitions();
  }

  loadFlowDefinitions(): void {
    this.loading = true;
    this.error = null;

    // // 使用 Mock 資料來獲取簽核流程定義
    // this.approvalService.getMockFlowDefinitions().subscribe({
    //   next: (flows) => {
    //     this.flowDefinitions = flows.filter(flow => flow.status === 'active');
    //     this.loading = false;
    //   },
    //   error: (err) => {
    //     this.error = '載入簽核流程失敗';
    //     console.error('Error loading approval flow definitions', err);
    //     this.loading = false;
    //   }
    // });
  }

  selectFlow(flow: ApprovalFlowDefinition): void {
    if (this.selectedFlow?.id === flow.id) {
      // 如果已選擇同一個流程，則取消選擇
      this.selectedFlow = null;
      this.flowDeselected.emit();
    } else {
      this.selectedFlow = flow;
      this.flowSelected.emit(flow);
    }
  }

  isFlowSelected(flow: ApprovalFlowDefinition): boolean {
    return this.selectedFlow?.id === flow.id;
  }

  getFlowDisplayText(flow: ApprovalFlowDefinition): string {
    const stepsCount = flow.steps?.length || 0;
    const formTypesText = flow.formTypes?.join(', ') || '所有表單';
    return `${stepsCount} 個步驟 • 適用於: ${formTypesText}`;
  }
}
